import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { UserService } from '../../services/user/user.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private userService: UserService) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      let isAuthenticated = this.userService.isAuthenticated();
      if (isAuthenticated) {
            // logged in so return true
            return isAuthenticated;
        }
      // not logged in so redirect to login page with the return url
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});

      //overriding authentication return false;
      //return isAuthenticated;
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/guards/auth/auth.guard.ts